import type { StorageUnit } from 'store/storageunits/types';

/**
 * Determines if a storage unit is a project.
 * A unit is considered a project if it has project metadata.
 *
 * Both internal and external users can view projects.
 * External users cannot create projects and have read-only access to the opportunity number field.
 *
 * @param unit - The storage unit to check
 * @returns true if the unit is a project, false otherwise
 */
export const isProject = (unit: StorageUnit): boolean => {
  return !!unit.project;
};
